window.addEventListener("load", function () {    
   
   
});